module.exports = {
      id: "icon-card-discover-usage",
      viewBox: "0 0 44 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-card-discover",
      toString: function () {
        return this.url;
      }
    }